import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import UserContext from "../../../services/Context/UserContext"
import { Download } from "@mui/icons-material";

export default function AuditButton({chapters, sections}){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)
    
    const {user} = useContext(UserContext)

    const [loading, setLoading] = useState(false);

    const handleClick = () => {

        setLoading(true)

        API.post(`/courses/${id}/audit/plan`, null)
            .then(r => {
                chapters.refetch()
                sections.refetch()
            })
            .catch(e => setToast({
                severity: 'error',
                message: "Les chapitres n'ont pas pu être importés."
            }))
            .finally(() => setLoading(false))
    }

    return user.admin && 
        <LoadingButton
            startIcon={<Download />}
            loading={loading}
            onClick={handleClick}
        >
            Import EPP
        </LoadingButton>
}